"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.footerStyle = exports.FootDivider = exports.StyledFooter = exports.socialMediaIcon = exports.ListItem = exports.List = exports.menuColumn = exports.FullWidthDivider = exports.Divider = exports.flexWidth = exports.LogoContainer = exports.SearchContainer = exports.MetalFinder = void 0;

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = require("@emotion/react");

var polished_1 = require("polished");

exports.MetalFinder = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tmargin: 20px 0px;\n"])));
exports.SearchContainer = styled_1.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tmargin-bottom: 20px;\n"])));
exports.LogoContainer = styled_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tpadding-top: 113px;\n\tpadding-bottom: 83px;\n"])));
exports.flexWidth = (0, react_1.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tpadding-left: 25px;\n\tpadding-right: 25px;\n"])));
exports.Divider = styled_1.default.hr(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\tmargin-top: 20px;\n\tmargin-bottom: 20px;\n\topacity: 0.1;\n\t", ";\n"])), function (props) {
  var color = props.color;
  return (0, react_1.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t\t\tborder-top: 1px solid ", ";\n\t\t"])), color);
});
exports.FullWidthDivider = styled_1.default.hr(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\topacity: 0.1;\n\t", ";\n"])), function (props) {
  var color = props.color;
  return (0, react_1.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\t\t\tborder-top: 1px solid ", ";\n\t\t"])), color);
});
exports.menuColumn = (0, react_1.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\twidth: 200px;\n"])));
exports.List = styled_1.default.ul(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n\tlist-style: none;\n\tmargin: 0;\n\tpadding-inline-start: 0px;\n"])));
exports.ListItem = styled_1.default.li(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n\tlist-style-type: none;\n\tpadding-bottom: 10px;\n"])));
exports.socialMediaIcon = (0, react_1.css)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n\tpadding-right: 20px;\n"])));
exports.StyledFooter = styled_1.default.footer(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n\tmargin: 0;\n\tpadding: 0;\n\t", ";\n"])), function (props) {
  var backColor = props.backColor,
      borderColor = props.borderColor,
      height = props.height;
  return (0, react_1.css)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n\t\t    ", "\n\t         ", "\n\t\t\tbackground-color: ", ";\n\t\t"])), height && "min-height: ".concat(height, "px;"), borderColor && "border-top: 1px solid ".concat((0, polished_1.rgba)(borderColor, 0.1), ";"), backColor);
});
exports.FootDivider = styled_1.default.hr(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n\tposition: relative;\n\tleft: -20px;\n\topacity: 0.1;\n\twidth: calc(100% + 40px);\n\t", ";\n"])), function (props) {
  var color = props.color;
  return (0, react_1.css)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n\t\t\tborder-top: 1px solid ", ";\n\t\t"])), color);
});

var footerStyle = function footerStyle(props) {
  var backColor = props.backColor,
      borderColor = props.borderColor,
      height = props.height;
  return (0, react_1.css)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n\t\t", "\n\t\t", "\n\t\tbackground-color: ", ";\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t \n\t"])), height && "min-height: ".concat(height, "px;"), borderColor && "border-top: 1px solid ".concat((0, polished_1.rgba)(borderColor, 0.1), ";"), backColor);
};

exports.footerStyle = footerStyle;